module.exports = __webpack_public_path__ + "static/img/no2.d2c83bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardPH/img/no2.png
// module id = xpVZ
// module chunks = 1